// extracted by mini-css-extract-plugin
export var icon = "_4v-1";
export var subtext = "_4v-0";